// Home "Graphite + Lime" — the data side (2026-10-27). The SAME reads the Premium Today screen made, nothing new:
// /weekly-plan/all-active, /garmin/activities, /garmin/status and the newest run's /garmin/activities/{id}/splits
// (database reads). The coach line, the next race and the routes come from App.js (already loaded there). No AI is
// called: the coach line is the stored /insights/workout-trend text.
import React, { useEffect, useState } from 'react';
import authFetch from '../../utils/authFetch';
import { fetchGarminActivities, fetchGarminSplits, fetchGarminStatus } from '../../utils/garmin';
import { garminHomeState } from '../home2/TrainingSourcesCard';
import HomeGraphite from './HomeGraphite';
import { lastRun } from './homeGraphiteModel';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://claude-coach-backend-1.onrender.com';

export default function HomeGraphiteHome({ userId, trend, nextRace, onNavigate, onConnect, footer, today,
  onDeepAnalyze, deepAnalyzing, onViewDeepAnalysis, injury, onUpdateInjury }) {
  const [plans, setPlans] = useState(null);           // null = loading
  const [acts, setActs] = useState(null);             // null = loading; [] = none / no feed
  const [garmin, setGarmin] = useState(null);
  const [splitsById, setSplitsById] = useState({});

  useEffect(() => {
    if (!userId) return undefined;
    let live = true;
    authFetch(`${API_BASE_URL}/weekly-plan/all-active?user_id=${encodeURIComponent(userId)}`)
      .then((r) => (r && r.ok ? r.json() : null))
      .then((d) => { if (live) setPlans(d || []); })
      .catch(() => { if (live) setPlans([]); });
    fetchGarminActivities(30)
      .then((list) => { if (live) setActs(list); })
      .catch(() => { if (live) setActs([]); });
    fetchGarminStatus()
      .then((s) => { if (live) setGarmin(s); })
      .catch(() => { /* unknown status: no device alert (a failed request is never shown as "not connected") */ });
    // a plan change approved in the chat (Chat.jsx) or a regenerated plan refreshes the plan cards in place
    const onPlans = () => {
      authFetch(`${API_BASE_URL}/weekly-plan/all-active?user_id=${encodeURIComponent(userId)}`)
        .then((r) => (r && r.ok ? r.json() : null))
        .then((d) => { if (live && d) setPlans(d); })
        .catch(() => {});
    };
    window.addEventListener('plansUpdated', onPlans);
    return () => { live = false; window.removeEventListener('plansUpdated', onPlans); };
  }, [userId]);

  const last = lastRun(acts);
  const garminId = last && last.source === 'garmin' ? last.garmin_id : null;
  useEffect(() => {
    if (!garminId || splitsById[garminId] !== undefined) return undefined;
    let live = true;
    fetchGarminSplits(garminId)
      .then((s) => { if (live) setSplitsById((m) => ({ ...m, [garminId]: s })); })
      .catch(() => { if (live) setSplitsById((m) => ({ ...m, [garminId]: [] })); });
    return () => { live = false; };
  }, [garminId, splitsById]);

  // A readable activity feed: activities came back, or the watch is connected (then "no runs" is a fact).
  const hasFeed = Array.isArray(acts) && (acts.length > 0 || garminHomeState(garmin) === 'connected');
  return (
    <HomeGraphite today={today || new Date()} plans={plans} activities={acts || []} hasFeed={hasFeed} garmin={garmin}
                  splits={garminId ? (splitsById[garminId] || null) : null} trend={trend} nextRace={nextRace}
                  loading={plans === null || acts === null} onNavigate={onNavigate} onConnect={onConnect}
                  footer={footer} onDeepAnalyze={onDeepAnalyze} deepAnalyzing={deepAnalyzing}
                  onViewDeepAnalysis={onViewDeepAnalysis} injury={injury} onUpdateInjury={onUpdateInjury} />
  );
}
